import React from 'react';

import { cssMap, cx } from '@atlaskit/css';
import { Box } from '@atlaskit/primitives/compiled';

import type { Size } from './types';

const styles = cssMap({
	iconContainerStyles: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
	},
	iconContainerStylesSmall: {
		width: '16px',
		height: '16px',
	},
	iconContainerStylesMedium: {
		width: '24px',
		height: '24px',
	},
	iconContainerStylesLarge: {
		width: '32px',
		height: '32px',
	},
	iconContainerStylesXlarge: {
		width: '32px',
		height: '32px',
	},
});

export interface SVGIconProps {
	glyph: () => JSX.Element;
	label?: string;
	size: Size;
	testId?: string;
}

export function SVGIcon({ glyph: SVG, label, size, testId }: SVGIconProps) {
	return (
		<Box
			xcss={cx(
				styles.iconContainerStyles,
				size === 'small' && styles.iconContainerStylesSmall,
				size === 'medium' && styles.iconContainerStylesMedium,
				size === 'large' && styles.iconContainerStylesLarge,
				size === 'xlarge' && styles.iconContainerStylesXlarge,
			)}
			aria-label={label}
			testId={testId}
		>
			<SVG />
		</Box>
	);
}
